import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface CircledXProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const CircledX: React.FunctionComponent<React.PropsWithChildren<CircledXProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 174.24 174.24" height={height} width={width} title={title} fill={fill} {...rest}>
        <path d="M 87.12 174.24 A 87.219 87.219 0 0 1 0 87.12 A 87.219 87.219 0 0 1 87.12 0 a 87.219 87.219 0 0 1 87.12 87.12 A 87.219 87.219 0 0 1 87.12 174.24 Z m 0 -76.554 h 0 l 23.15 23.153 a 7.419 7.419 0 0 0 5.28 2.188 a 7.418 7.418 0 0 0 5.279 -2.188 a 7.475 7.475 0 0 0 0 -10.559 l -23.152 -23.153 l 23.151 -23.152 a 7.419 7.419 0 0 0 2.188 -5.28 a 7.419 7.419 0 0 0 -2.188 -5.28 a 7.42 7.42 0 0 0 -5.281 -2.188 a 7.407 7.407 0 0 0 -5.277 2.188 l -23.151 23.154 l -23.152 -23.154 a 7.418 7.418 0 0 0 -5.279 -2.188 a 7.418 7.418 0 0 0 -5.279 2.188 a 7.476 7.476 0 0 0 0 10.56 l 23.151 23.152 L 53.409 110.28 a 7.475 7.475 0 0 0 0 10.559 a 7.419 7.419 0 0 0 5.28 2.188 a 7.409 7.409 0 0 0 5.279 -2.188 l 23.151 -23.153 Z" />
    </SVGBase>
);

export default CircledX;
